export const chartStatusTypes = [
    // {
    //     key: "accepted",
    //     label: "Accepted",
    //     lineColor: [54, 162, 235]
    // },
    {
        key: "success",
        label: "Success",
        lineColor: [40, 167, 69]
    },
    {
        key: "failure",
        label: "Failure",
        lineColor: [220, 23, 69]
    },
    // {
    //     key: "in_process",
    //     label: "In-Process",
    //     lineColor: [255, 193, 7]
    // }
];

export const generateTransfersChartDataSet = (label, lineColor, data) => {
    const dataset = {
        label: label,
        fill: false,
        lineTension: 0.4,
        backgroundColor: `rgb(${lineColor[0]}, ${lineColor[1]}, ${lineColor[2]}, 0.4)`,
        borderColor: `rgb(${lineColor[0]}, ${lineColor[1]}, ${lineColor[2]}, 0.7)`,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: data
    }
    return dataset;
};

export const generatePaymentModeDataSet = (data) => {

    let data_arr = Object.values(data)
    // let _ = Object.keys(data).includes("AMAZON WALLET") ? data_arr.push(data["AMAZON WALLET"]) : null;
    const dataset = {
        data: data_arr,
        backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#ADE321'
        ],
        hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#ADE321'
        ]
    }
    return dataset;
};

export const generatePaymentSourceDataSet = (data) => {
    const dataset = {
        data: [data.dashboard, data.api],
        backgroundColor: [
            '#ADE321',
            '#20FBA3'
        ],
        hoverBackgroundColor: [
            '#ADE321',
            '#20FBA3'
        ]
    }
    return dataset;
};